import $ from 'jquery'
import select2 from "select2"
window.jQuery = $
window.$ = $
import Nav from './components/Nav'
import Modal from './components/Modal'
import MobileAcco from './components/MobileAcco'
import Acco from './components/MobileAcco'
import City from './components/City'
import Warehouse from './components/Warehouse'
import './components/jquery.validate.min'
import inputmask from 'inputmask/dist/jquery.inputmask.js'
import './components/jquery.inputmask-multi.min'
import SimpleLightbox from 'simple-lightbox'

import Swiper, { Navigation, Pagination } from 'swiper'

import * as Sentry from "@sentry/browser"
import { BrowserTracing } from "@sentry/tracing"

import LazyLoad from "vanilla-lazyload"

jQuery(function(){

	Sentry.init({
		dsn: "https://92d498a343774288b37f1e7280228b57@sntr.lorem.su/3",
		integrations: [new BrowserTracing()],
		tracesSampleRate: 1.0,
	})

	document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`)

	const lazyLoadInstance = new LazyLoad()

	$('.js-select').each(function() {

		const placeholder = $(this).attr('data-placeholder')
		$(this).select2(
			{
				placeholder: placeholder,
				minimumResultsForSearch: Infinity,
				dropdownCssClass: "select__dropdown",
				selectionCssClass: 'select__selection'
			}
		)
		$('.js-select[name="region"]').select2(
			{
				placeholder: 'Город, регион',
				minimumResultsForSearch: Infinity,
				dropdownCssClass: "select__dropdown",
				selectionCssClass: 'select__selection'
			}
		)
	})

	$('.js-select').on("change", function (){
		$(this).removeClass('error')
	})

	$('[data-component="nav"]').each(function() {
		new Nav(this)
	})
	$('[data-modal-trigger]').each(function() {
		new Modal(this)
	})
	$('[data-js-city]').each(function() {
		new City(this)
	})
	$('[data-js-warehouse]').each(function() {
		new Warehouse(this)
	})
	if($(window).width() <= 743){
		$('[data-js-mobile-acco]').each(function() {
			new MobileAcco(this)
		})
	}
	$('[data-js-acco]').each(function() {
		new Acco(this)
	})

	let scrollPos = 0

	function handleScroll() {
		let st = window.scrollY
		const innerHeight = window.innerHeight
		const footerEl = document.querySelector('.footer')
		const footerPosition = footerEl?.offsetTop || 0
		const isFixed = st >= window.innerHeight && st < footerPosition - innerHeight
		if (isFixed) {
			$('.scroll-to-top').addClass('fixed')
		} else {
			$('.scroll-to-top').removeClass('fixed')
		}

		scrollPos = st
	}

	window.addEventListener("scroll", handleScroll)

	$('.scroll-to-top__btn').on('click', () => {
		const el = document.querySelector('.wrapper')
		if (el) {
			el.scrollIntoView({block: "start", behavior: "smooth"})
			return true
		}
	})

	function getCookie(name) {
		let matches = document.cookie.match(new RegExp(
			"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		))
		return matches ? decodeURIComponent(matches[1]) : undefined
	}

	$(document).ready(() => {

		const params = window
			.location
			.search
			.replace('?','')
			.split('&')
			.reduce(
				function(p,e){
					const a = e.split('=')
					p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1])
					return p
				},
				{}
			)

		if (params['scroll'] === 'y') {
			const el = document.querySelector('.contacts')
			if (el) {
				el.scrollIntoView({block: "start", behavior: "smooth"})
			}
		}

		if (!getCookie('cookieHide')) {
			$('.cookie').removeClass('hidden')
		}
	})

	$('.cookie__close').on('click', () => {
		$('.cookie').addClass('hidden')
	})

	$('.cookie__btn').on('click', () => {
		$('.cookie').addClass('hidden')
		document.cookie = "cookieHide=true; max-age=2592000, path='/'"
	})

	function showModal(el) {
		$('[data-modal]').fadeOut()
		el.stop().fadeIn()
	}

	$('.modal__close').on('click', () => {
		$('[data-modal]').fadeOut()
	})

	const projectSwiper = new Swiper('.project-swiper', {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 0,
		mousewheel: true,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.project-swiper__button--next',
			prevEl: '.project-swiper__button--prev',
		}
	})

	const warehouseSwiper = new Swiper('.warehouse-swiper', {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 0,
		mousewheel: true,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.warehouse-swiper__button--next',
			prevEl: '.warehouse-swiper__button--prev',
		}
	})

	const mapSwiper = new Swiper('.dynamic-map-swiper', {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 0,
		mousewheel: true,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.dynamic-map-swiper__button--next',
			prevEl: '.dynamic-map-swiper__button--prev',
		}
	})

	const lightbox = new SimpleLightbox({elements: '.js-lightbox'})

	if ($(document).find('.contacts__map').length > 0) {
		ymaps.ready(init)
	}

	function init(){
		$('.contacts__map').each(function () {
			const id = this.id
			const coords = $(this).attr('data-coords').split(',')
			const myMap = new ymaps.Map(id, {
				center: coords,
				controls: ['zoomControl'],
				zoom: 12
			})
			const myPlacemark = new ymaps.Placemark(coords, {}, {
				iconLayout: 'default#image',
				iconImageHref: ' /local/templates/rima/front/build/assets/img/pin.png',
				iconImageSize: [20, 35],
				iconImageOffset: [-10, -35]
			})
			myMap.geoObjects.add(myPlacemark)
		})
	}

	$('input[type="tel"]').each(function() {
		const $this = this
		const curUrl = '/local/templates/rima/front/build/assets/_data/phone-codes.json'

		if ($.masksLoad(curUrl)) {
			let maskList = $.masksSort($.masksLoad(curUrl), ['#'], /[0-9]|#/, "mask")
			let maskOpts = {
				inputmask: {
					definitions: {
						'#': {
							validator: "[0-9]",
							cardinality: 1
						}
					},
					showMaskOnHover: false,
					autoUnmask: true,
					clearMaskOnLostFocus: true,
					clearIncomplete: true
				},
				match: /[0-9]/,
				replace: '#',
				list: maskList,
				listKey: "mask",
				onMaskChange: function (maskObj, determined) {
					// if (determined) {
					// 	let hint = maskObj.name_en
					// 	if (maskObj.desc_en && maskObj.desc_en != "") {
					// 		hint += " (" + maskObj.desc_en + ")"
					// 	}
					// 	$("#descr").html(hint)
					// } else {
					// 	$("#descr").html("Mask of input")
					// }
				}
			}

			if ($(this).inputmask) {
				$(this).inputmask('remove')
			}

			$(this).inputmasks(maskOpts)
		}
	})

	jQuery.validator.addMethod("checkName", function (value, element) {
		let pattern = new RegExp(/^([-а-яёА-ЯЁ\s]*?)$/)
		return pattern.test(value)
	})

	jQuery.validator.addMethod("checkEmail", function (value, element) {
		let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)
		return pattern.test(value)
	})

	jQuery.validator.addMethod('password', function (value) {
		let valid = false
		if (value.match('[A-Z]+') && value.match('[a-z]+') && value.match('[0-9]+') && value.match('[\\][,.<>/?:\'"{}|`~\!@#$%^&*()_+=\\\\-]+')) {
			valid = true
		}
		return valid
	}, '')

	jQuery.validator.addMethod("requireFromGroup", function (value, element, options) {
		let numberRequired = options[0]
		let selector = options[1]
		let fields = $(selector, element.form)
		let filled_fields = fields.filter(function () {
			return $(this).val() !== ""
		})
		let empty_fields = fields.not(filled_fields)
		return !(filled_fields.length < numberRequired && empty_fields[0] === element)
	}, '')

	$('form[data-check-form]').each(function (elem, index) {
		let $this = $(this)

		$this.validate({
			errorClass: "error",
			validClass: "success",
			errorElement: "em",
			focusInvalid: true,
			invalidHandler: function (event, validator) {
				let errors = validator.numberOfInvalids()
				if (errors) {
					console.log(errors)
				}
			},
			submitHandler: function (form) {
				$("em.error").hide()

				let curForm = form
				let url = $this.attr('data-api')
				let formData = new FormData(curForm)

				$.ajax({
					url: url,
					method: 'POST',
					contentType: false,
					processData: false,
					data: formData,
					dataType: 'json',
					success: function (data) {
						const modalEl = $('[data-modal="success"]')
						if (data.success) {
							modalEl.find('.modal__title').text(data.title)
							modalEl.find('.modal__text').text(data.text).removeClass('error')
							showModal(modalEl)
							$this.trigger('reset')
							$('.js-select').val(null).trigger('change')
						} else {
							modalEl.find('.modal__title').text(data.title)
							modalEl.find('.modal__text').text(data.text).addClass('error')
						}
					},
					error: function (data) {
						console.log(data)
					}
				})
			},
			highlight: function (element, errorClass, validClass) {
				$(element).addClass(errorClass).removeClass(validClass)
			},
			unhighlight: function (element, errorClass, validClass) {
				$(element).removeClass(errorClass).addClass(validClass)
			},
			errorPlacement: function (error, element) {
				// if ($(element).parent().hasClass('base-checkbox') || $(element).parent().hasClass('base-radio')) {
				// 	error.insertBefore(element)
				// } else {
				// 	error.insertAfter(element)
				// }
			}
		})
	})

	$('.js-required-file').each(function () {
		$(this).rules('add', {
			required: true,
			messages: {
				required: "Загрузите резюме"
			}
		})
	})

	$('input[required]').each(function () {
		$(this).rules('add', {
			required: true,
			messages: {
				required: "Обязательное поле"
			}
		})
	})

	$('textarea[required]').each(function () {
		$(this).rules('add', {
			required: true,
			messages: {
				required: "Обязательное поле"
			}
		})
	})

	$('select[required]').each(function () {
		$(this).rules('add', {
			required: true,
			messages: {
				required: "Обязательное поле"
			}
		})
	})

	$('.js-required-text').each(function () {
		$(this).rules('add', {
			checkName: true,
			messages: {
				checkName: "Недопустимые символы"
			}
		})
	})

	$('.region-form').on('submit', (e) => {
		e.preventDefault()
		let curForm = document.querySelector('.region-form')
		let url = $('.region-form').attr('data-api')
		let formData = new FormData(curForm)

		$.ajax({
			url: url,
			method: 'POST',
			contentType: false,
			processData: false,
			data: formData,
			dataType: 'json',
			success: function (data) {
				if (data.success) {
					window.location = data.link
				}
			},
			error: function (data) {
				console.log(data)
			}
		})
	})

	$('.aside-controls__btn').on('click', function () {
		$('.aside-controls__btn').removeClass('active')
		$(this).addClass('active')
	})
})
